module.exports = __webpack_public_path__ + "static/media/warning.da9dbd10.svg";